module.exports = __webpack_public_path__ + "b8c9f5e4fa65dc17c5f07773616fa3cb.svg";